import GlobalVars, { KEYS } from '../utils/GlobalVars'
import { TA_CAT_ATTRACTION, TA_CAT_HOTEL, TA_CAT_RESTAURANT } from './tripadvisor'
import PoiOpeningHours from './PoiOpeningHours'
import ConfigFunctions from '../components/TripAdvisor/ConfigFunctions'

const CONFIG_FUNCTIONS = new ConfigFunctions()
//
//
// The name of the functions corresponds to those given by Tripadvisor
//      -> https://developer-tripadvisor.com/content-api/documentation/
// ----------------------------------------------------------------------------
class Poi {

  constructor (json) {
    if (json) {
      Object.keys(json).forEach(key => {
        this[key] = json[key]
      })

      this.isVisible = true

      // this.location_id = json.location_id || json.id
      // this.name = json.name
      // this.category = json.category
      // this.address = json.address
      //
      // this.ranking = json.ranking
      // this.rankingString = json.rankingString
      // this.ratingImageUrl = json.ratingImageUrl
      // this.rating = json.rating
      // this.reviewCount = json.reviewCount
      // this.tripAdvisorUrl = json.tripAdvisorUrl
      // this.tripAdvisorPhotoUrl = json.photoUrl
      // this.photoUrl = json.photoUrl
      // this.description = json.description

      const config = GlobalVars.get(KEYS.CONFIG)
      const categoriesConfig = config ? config.getCategoriesConfig() : null
      const categoryConfig = categoriesConfig ? categoriesConfig[this.category] : null
      const icons = categoryConfig ? categoryConfig.icons || {} : {}
      this.iconsConditioned = categoryConfig ? categoryConfig.iconsConditioned : null

      this.icons = {}
      if (icons.marker) {
        this.icons.MARKER = icons.marker
      }
      this.icons.MARKER_HIGHLIGHTED = icons.marker_highlighted || this.icons.MARKER
      this.icons.SETTINGS = icons.settings || this.icons.MARKER
      this.icons.DEFAULT = icons.default || this.icons.MARKER

      // for references from configs, do not remove!
      this.icons_marker = this.icons.MARKER
      this.icons_marker_highlighted = this.icons.MARKER_HIGHLIGHTED
      this.icons_default = this.icons.DEFAULT || CONFIG_FUNCTIONS.eval(this.iconsConditioned.default, this, true)

      this.openingHours = this.parseHours(json.openingHours) || json.openingHours

      this.lng = parseFloat(json.location.lng)
      this.lat = parseFloat(json.location.lat)

      this.extraData = categoryConfig && categoryConfig.hasOwnProperty('needsExtraData') ? !categoryConfig.needsExtraData : true

      this.source = categoryConfig.source
    }
  }

  /**
   *
   * @param otherPoi {Poi}
   * @return {boolean}
   */
  equals (otherPoi) {
    return this.id === otherPoi.id &&
      this.lng === otherPoi.lng &&
      this.lat === otherPoi.lat
  }

  /**
   * Calculates the distance to a given coordinate
   * @param latlng {{lat: number, lng: number}}
   * @returns {{distanceInMeter: number, distanceString: string}}
   */
  getDistanceTo (latlng) {
    // calculations taken from http://www.movable-type.co.uk/scripts/latlong.html

    const toRadians = (number) => number * Math.PI / 180
    // const toDegrees = (number) => number * 180 / Math.PI;

    if (latlng && latlng.lat && latlng.lng) {
      const lat1 = this.lat
      const lng1 = this.lng
      const lat2 = latlng.lat
      const lng2 = latlng.lng

      const R = 6371e3 // metres
      const phi1 = toRadians(lat1)
      const phi2 = toRadians(lat2)
      const deltaPhi = toRadians(lat2 - lat1)
      const deltaLambda = toRadians(lng2 - lng1)

      const a = (Math.sin(deltaPhi / 2) * Math.sin(deltaPhi / 2)) +
        (Math.cos(phi1) * Math.cos(phi2) * Math.sin(deltaLambda / 2) * Math.sin(deltaLambda / 2))
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

      const d = R * c
      const distanceInMeter = Math.round(d / 10) * 10

      const locale = GlobalVars.get(KEYS.LOCALE)
      let distanceString
      if (distanceInMeter > 10000) {
        distanceString = `${Math.round(distanceInMeter / 1000).toLocaleString(locale)}km`
      }
      else if (distanceInMeter > 1000) {
        distanceString = `${parseFloat((distanceInMeter / 1000).toFixed(1)).toLocaleString(locale)}km`
      }
      else {
        distanceString = `${distanceInMeter.toLocaleString(locale)}m`
      }

      return {
        distanceInMeter,
        distanceString
      }
    }
    return null
  }

  /**
   * This function is referenced from config files so don't delete it!
   * @param latlng
   * @returns {string}
   */
  getDistanceStringTo (latlng) {
    const distance = this.getDistanceTo(latlng)
    if (distance) {
      return distance.distanceString
    }
    console.error({latlng, distance})
    return ''
  }

  getMarkerIcon (configFunctions) {
    if (this.iconsConditioned && this.iconsConditioned.marker) {
      return configFunctions.eval(this.iconsConditioned.marker, this)
    }
    return this.icons.MARKER
  }

  getMarkerHighlightedIcon (configFunctions) {
    if (this.iconsConditioned && this.iconsConditioned.marker_highlighted) {
      return configFunctions.eval(this.iconsConditioned.marker_highlighted, this)
    }
    return this.icons.MARKER_HIGHLIGHTED
  }

  /**
   *
   * @returns {{lng: Number, lat: Number}}
   */
  getPosition () {
    return {
      lng: this.lng,
      lat: this.lat
    }
  }

  /**
   * Checks if this POI is within given bounds
   * @param bounds {{nw: {lat: number, lng: number}, se: {lat: number, lng: number}}}
   */
  isInArea (bounds) {
    return !bounds || (this.lat <= bounds.nw.lat &&
      this.lat >= bounds.se.lat &&
      this.lng >= bounds.nw.lng &&
      this.lng <= bounds.se.lng)
  }

  isHotel () {
    return this.category === TA_CAT_HOTEL
  }

  isRestaurant () {
    return this.category === TA_CAT_RESTAURANT
  }

  isAttraction () {
    return this.category === TA_CAT_ATTRACTION
  }

  /**
   *
   * @returns {null |
   *   {
   *    Monday: null | PoiOpeningHours,
   *    Tuesday: null | PoiOpeningHours,
   *    Wednesday: null | PoiOpeningHours,
   *    Thursday: null | PoiOpeningHours,
   *    Friday: null | PoiOpeningHours,
   *    Saturday: null | PoiOpeningHours,
   *    Sunday: null | PoiOpeningHours,
   *    }
   *   }
   * }
   */
  parseHours (hoursJson) {
    if (hoursJson) {
      const weekRangesJson = hoursJson.week_ranges
      const timeZone = hoursJson.timezone

      const weekRanges = {
        Monday: null,
        Tuesday: null,
        Wednesday: null,
        Thursday: null,
        Friday: null,
        Saturday: null,
        Sunday: null
      }
      let success = false
      if (weekRangesJson) {
        weekRangesJson.forEach(dayRange => {
          const dayHours = new PoiOpeningHours(dayRange, timeZone)
          weekRanges[dayHours.day] = dayHours
          if (dayHours) {
            success = true
          }
        })
      }

      if (success) {
        return weekRanges
      }
    }
    return null
  }

  setDescription (description) {
    this.description = description
  }

  setHasExtraData (value) {
    this.extraData = value
  }

  setPhotoUrl (photoUrl) {
    this.photoUrl = photoUrl
  }

}

export default Poi



// WEBPACK FOOTER //
// ./src/data/Poi.js